import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLock, FiUser, FiAlertCircle } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import PageTransition from '../../components/PageTransition';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');

    // Simple hardcoded check for the admin portal
    // Email: admin@rvenue.com
    // Password: admin123
    if (email === 'admin@rvenue.com' && password === 'admin123') {
      // In a real app, you'd set a session/token here
      localStorage.setItem('rvenue_admin_session', 'active');
      navigate('/admin');
    } else {
      setError('Invalid admin credentials. Please try again.');
    }
  };

  return (
    <PageTransition>
      <div className="min-h-screen bg-brand-cream flex items-center justify-center p-6">
        <div className="max-w-md w-full bg-white p-10 rounded-sm shadow-xl border border-brand-light/30">
          <div className="text-center mb-10">
            <h1 className="font-serif text-3xl text-brand-olive uppercase tracking-widest font-bold">R. Venue</h1>
            <p className="text-brand-sage text-sm mt-2 uppercase tracking-tighter">Management Portal</p>
          </div>

          {error && (
            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-xs flex items-center gap-3">
              <SafeIcon icon={FiAlertCircle} className="text-lg" />
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-xs uppercase tracking-widest text-brand-sage mb-2 font-bold">Admin Email</label>
              <div className="relative">
                <SafeIcon icon={FiUser} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-light" />
                <input 
                  type="email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-brand-cream/30 border border-brand-light/50 focus:border-brand-olive outline-none transition-colors text-sm" 
                  placeholder="admin@rvenue.com" 
                  required 
                />
              </div>
            </div>

            <div>
              <label className="block text-xs uppercase tracking-widest text-brand-sage mb-2 font-bold">Password</label>
              <div className="relative">
                <SafeIcon icon={FiLock} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-light" />
                <input 
                  type="password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 bg-brand-cream/30 border border-brand-light/50 focus:border-brand-olive outline-none transition-colors text-sm" 
                  placeholder="••••••••" 
                  required 
                />
              </div>
            </div>

            <button 
              type="submit" 
              className="w-full bg-brand-olive text-brand-cream py-4 uppercase tracking-[0.2em] font-bold hover:bg-brand-dark transition-all duration-300 shadow-lg active:scale-[0.98]"
            >
              Sign In
            </button>
          </form>

          <div className="mt-8 p-4 bg-brand-cream/50 rounded-sm">
            <p className="text-[10px] text-brand-sage uppercase tracking-widest font-bold mb-1">Demo Access:</p>
            <p className="text-[10px] text-brand-sage italic">Email: admin@rvenue.com</p>
            <p className="text-[10px] text-brand-sage italic">Pass: admin123</p>
          </div>

          <p className="mt-8 text-center text-[10px] text-brand-sage italic uppercase tracking-tighter">
            Authorized access only. All actions are logged locally.
          </p>
        </div>
      </div>
    </PageTransition>
  );
};

export default AdminLogin;